import React from "react";
import {Table, Button} from "reactstrap";
import {useSelector, useDispatch } from 'react-redux';
import {globals} from "../Globals/Globals"
import NestedTitlePicture3 from "../NestedTitlePicture3/NestedTitlePicture3";
import { openModalAward } from "../../redux/modalSlice";
import {openModalStat, openModal} from "../../redux/modalSlice";
import {deleteAward, revertStatusAwards} from "../../redux/awardSlice"

const AwardsRawTableDataSync = (props) => {
    const dispatch = useDispatch();
    const {deleteAward_result} = useSelector((state)=>state.awards)

    React.useEffect(() => {
        // eslint-disable-next-line no-unused-vars
        let isMounted = true

        if (deleteAward_result.status == "deleted"){
            try{
                dispatch(openModal({title:"Hotel du mois supprimé"}));
            }
            finally{
                dispatch(revertStatusAwards())
            }
        }

        // Cleanup function
        return () => {
            isMounted = false;
        }
    }, [dispatch, deleteAward_result]);

     /**
     * 
     * @param {*} this 
     * @param {*} handleManager 
     * @param {*} userItem 
     * @param {*} data_guid 
     */
    const handleManager = async (p_s_item_key, p_callback_handler) => {
        try {
            if (globals.parameters.debugging) console.log("handleManager::p_s_item_key =>", p_s_item_key)
                p_callback_handler(props.awards_list.find((item) => item.data_guid == p_s_item_key))
        } catch (error) {
            console.error(`handleManager for ${p_callback_handler} raise error ${error.message}`)
            alert(`handleManager for ${p_callback_handler} raise error ${error.message}`)
        }
    }

    /**
     * tableRendering
     */
    const tableRendering = () => {
        let table_body = null;

        if (!((props.awards_list != null) && (props.awards_list.length > 0))){
            table_body = <tr><td colSpan="4">Aucun hôtel du mois</td></tr>;
        }
        else{
            table_body = props.awards_list.map((awardItem,i)=>{
                return  <tr key={awardItem.data_guid} className="thumbnail">
                            <td id="table-item-container">
                                <div id="table-item">
                                <NestedTitlePicture3
                                    title = {" "}
                                    pictureURL = {awardItem.data_blob.data_tier.award_hotel_photo}
                                    text = {awardItem.data_blob.data_tier.award_hotel_name}
                                    height = {"400px"}
                                    width = {"100%"}
                                    center = {true}
                                    color = {"white"}
                                />
                                </div>
                                <div id="table-commands">
                                    {!props.read_only &&
                                        <div className="cmd_btn_delete">
                                            <Button onClick={()=>{handleManager(awardItem.data_guid, (awardObject)=>{
                                                                                            dispatch(openModal(
                                                                                                {title:`Supprimer l'hotel du mois ${awardObject.data_blob.data_tier.award_hotel_name}} ?`,
                                                                                                 okCallBack:(DialogObject)=>{dispatch(deleteAward(awardObject))}})) })}}
                                            style={{cursor:"pointer"}}>Effacer</Button>
                                        </div>}
                                    
                                    {!props.read_only &&
                                        <div className="cmd_btn_update">
                                            <Button onClick={()=>{handleManager(awardItem.data_guid, (awardObject)=>{dispatch(openModalAward({award_data_guid:awardObject, read_only:false}))})}} 
                                            style={{cursor:"pointer"}}>Modifier</Button>
                                        </div>}
                                </div>
                            </td>
                        </tr>});
                }

        return(
            <Table striped responsive={true}>
               <tbody>
                    {table_body}
                </tbody>
            </Table>
            );
    }

    return (
        <>
            {tableRendering()}
        </>);
}

export default AwardsRawTableDataSync;
